module.exports = __webpack_public_path__ + "static/img/police.cd51431.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Copyright/police.png
// module id = MxL9
// module chunks = 39